import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const credentials = ['Doctora en Medicina — Universidad de Barcelona', 'Especialista en Endocrinología y Nutrición Clínica', 'Certificada en Medicina Funcional y Longevidad', 'Autora de 3 programas de salud hormonal femenina', '+12.000 mujeres transformadas en 28 países'];
export function Authority() {
  return <section className="bg-warm-white py-20 md:py-28" data-id="element-19">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-20">
        <div className="grid md:grid-cols-[280px_1fr] lg:grid-cols-[320px_1fr] gap-10 md:gap-14 lg:gap-16 items-start" data-id="element-21">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="mx-auto md:mx-0 w-full max-w-[280px]" data-id="element-22">
            <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl relative bg-cream" data-id="element-23">
              <img src="https://cdn.magicpatterns.com/uploads/i73EL7UiHdLvbjdnfCFQei/La_mayoria_llega_sin_esto…_(3).png" alt="Dra. Elisabeth Mayo — Médica especialista en Endocrinología Femenina" width={828} height={1104} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-24" />

              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-charcoal/85 via-charcoal/40 to-transparent p-5 md:p-6" data-id="element-25">
                <div className="flex items-center gap-2 mb-2" data-id="element-26">
                  <span className="h-px w-6 bg-gold-light" data-id="element-27"></span>
                  <span className="text-[10px] tracking-[0.2em] uppercase text-gold-light font-semibold" data-id="element-28">
                    Barcelona · Lic. Méd.
                  </span>
                </div>
                <p className="font-serif text-lg md:text-xl text-warm-white font-semibold leading-tight" data-id="element-29">
                  Dra. Elisabeth Mayo
                </p>
                <p className="text-xs md:text-sm text-warm-white/80 italic mt-0.5" data-id="element-30">
                  Endocrinología Femenina
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-31">
            <p className="text-xs md:text-sm font-bold tracking-[0.2em] text-gold uppercase mb-3" data-id="element-32">
              La mente detrás del sistema
            </p>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal leading-tight mb-2" data-id="element-33">
              Dra. Elisabeth Mayo
            </h2>

            <p className="text-charcoal/60 italic text-base md:text-lg mb-7" data-id="element-34">
              Médica especialista en Endocrinología Femenina y Longevidad
              Hormonal
            </p>

            <div className="space-y-5 text-charcoal/80 text-base md:text-lg leading-relaxed mb-8" data-id="element-35">
              <p data-id="element-36">
                Durante más de <strong data-id="element-37">15 años</strong>, la Dra. Mayo atendió a
                miles de mujeres que llegaban a su consulta con la misma
                historia: hacían todo bien y aun así su cuerpo no respondía. Los
                análisis salían "normales", pero ellas no se sentían normales.
              </p>
              <p data-id="element-38">
                Fue entonces cuando comenzó a investigar la intersección entre
                el <strong data-id="element-39">ritmo circadiano</strong>, la{' '}
                <strong data-id="element-40">señalización hormonal</strong> y el{' '}
                <strong data-id="element-41">metabolismo femenino</strong> en la etapa
                perimenopáusica — un campo que la medicina convencional había
                ignorado sistemáticamente.
              </p>
              <p data-id="element-42">
                El resultado fue el{' '}
                <span className="font-serif font-semibold text-forest" data-id="element-43">
                  Protocolo de Sincronización Hormonal
                </span>
                , hoy conocido como Código Hormonal 40+, que ha transformado la
                vida de más de{' '}
                <span className="text-gold font-semibold" data-id="element-44">
                  12.000 mujeres en 28 países
                </span>
                .
              </p>
            </div>

            <div className="space-y-3" data-id="element-45">
              {credentials.map((credential, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.2 + index * 0.08
            }} className="flex items-start gap-3" data-id="element-46">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-forest flex items-center justify-center mt-0.5" data-id="element-47">
                    <CheckIcon className="w-3 h-3 text-gold-light" strokeWidth={3} data-id="element-48" />
                  </div>
                  <p className="text-charcoal/85 text-sm md:text-base" data-id="element-49">
                    {credential}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}